module.exports = __webpack_public_path__ + "static/Banner-Equipment-faba0bcc527dae0ded15b2906816560e.png";